module.exports = __webpack_public_path__ + "img/frame05_normal.401bb698.png";